import React, { Component } from 'react';
import KalenderRow from '../components/KalenderRow'; 

class KalenderList extends Component { 
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
	}
	handleClick(name){
		this.props.handleClick(name);
	}
	render(){
		const { data,staticData }  = this.props;
		return(		
			<section className="events-calendar">			
				{
					data.map( (data,i)=>
						<KalenderRow staticData={staticData} handleClick={this.handleClick} key={i} {...data} />
					)
				}			
			</section>
		) 
	}	
}
export default KalenderList;




// WEBPACK FOOTER //
// ./src/components/KalenderList.js